import { useCallback } from 'react';
import { useListContext } from 'react-admin';
import { useSubscribeToRecordList } from './controller';
/**
 * Watches for events related to a record list in a ListContext, and triggers a refetch when one occurs.
 *
 * To be used e.g. in a `<List>` to trigger a refetch when a record is created, updated, or deleted.
 *
 * Requires react-admin 4.7.0 or later.
 *
 * @example
 * import { List, Datagrid } from 'react-admin';
 * import { ListLiveUpdate } from '@react-admin/ra-realtime';
 *
 * const PostList = () => (
 *     <List>
 *         <ListLiveUpdate />
 *         <Datagrid>
 *             <TextField source="title" />
 *         </Datagrid>
 *     </List>
 * );
 */
export var ListLiveUpdate = function (_a) {
    var onEventReceived = _a.onEventReceived;
    var refetch = useListContext().refetch;
    var callback = useCallback(function () { return refetch(); }, [refetch]);
    useSubscribeToRecordList(onEventReceived || callback);
    return null;
};
